import BrandmisuseIntelService from '../services/brandmisuse-intel-service';

export const brandmisuseIntel = {
  namespaced: true,
  state: {
    brandmisuse: null,
    searchResult: null,
    pageNumber: 0,
    lastSearchConfig: null,
  },
  actions: {
    get({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return BrandmisuseIntelService.get(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBrandmisuse', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    updateTradingStandards({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return BrandmisuseIntelService.updateTradingStandards(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBrandmisuse', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    search({ commit, state }, payload) {
      commit('setIsBusy', true, { root: true });
      const searchPayload = {
        ...payload,
        pageParameters: { number: state.pageNumber, size: 20 },
        sort: { direction: 'desc', item: 'dateRaised' },
      };
      commit('setLastSearchConfig', searchPayload);
      return BrandmisuseIntelService.search(searchPayload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setSearchResult', result);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    setPage({ commit, dispatch, state }, page) {
      commit('setPageNumber', page);
      return dispatch('search', state.lastSearchConfig || {});
    },
  },
  mutations: {
    setBrandmisuse(state, brandmisuse) {
      state.brandmisuse = brandmisuse;
    },
    setSearchResult(state, result) {
      state.searchResult = result;
    },
    setPageNumber(state, page) {
      state.pageNumber = page;
    },
    setLastSearchConfig(state, config) {
      state.lastSearchConfig = config;
    },
  },
};
